//STORE
import { usePinFlow } from '../../composables/usePinFlow';

//TYPES
import { PinType } from '../../types/pin.type';

export const usePinCreationModal = (emits) => {
  const pinFlow = usePinFlow();

  function goToCreatePin() {
    emits('update:modelValue', false);

    pinFlow.setFlowConfig({
      pinType: PinType.CREATE,
    });

    pinFlow.showPin();
  }

  return {
    goToCreatePin,
  };
};
